Application.Signature.Name = {
    ui: {
        container: '.js-signature-name.name-form',
        text: '.name-form__text-input',
        hidden: '.name-form__hidden-input',
        submit: '.name-form__submit',
        previewContainer: '.preview__content',
        previewText: '.preview-name'
    },
    ready: function (previewList) {

        if (!$(this.ui.container).length){
            return;
        }

        // assign
        this.previewList = previewList;

        // bind handlers
        this.bind();

    },
    bind: function(){

        var self = this;

        $(document).on('click', this.ui.submit, function(event){
            event.preventDefault();
            self.change($(self.ui.text).val());
        });
        $(document).on('keypress', this.ui.text, function(event){
            if (event.which === 13 /* Enter */){
                event.preventDefault();
                self.change($(self.ui.text).val());
            }
        });

    },
    change: function(name){

        var self = this;

        $(this.ui.hidden).val(name);
        $(this.ui.previewText).text(name);
        $(this.ui.previewContainer).attr('data-length', name.length);

        // recalculate DOM and reset icon size
        setTimeout(function(){
            self.previewList.reset();
        }, 0);

    }
}